import React, { useEffect } from "react";
import { useReportGenerationWebSocket } from "@pages/Report/utils/useReportGenerationWebSocket";
import LoadingBar from "@shared/components/LoadingBar";
import { useProgressWithNavigation } from "@pages/Report/utils/useProgressWithNavigation";
import Loader from "@shared/components/Loader";

interface ReportTrackerProps {
  taskId: string;
  onDone: () => void;
  completed: boolean;
  onDelete: (taskId: string) => void;
  failed: boolean;
  currentStep?: string;
}

const ReportTracker: React.FC<ReportTrackerProps> = ({
  taskId,
  onDone: statusUpdated,
  completed,
  onDelete,
  failed,
  currentStep,
}) => {
  const { reportStatus, progressMessage, reportId } =
    useReportGenerationWebSocket({
      taskId: !completed && !failed ? taskId : "",
    });

  const [processing, setProcessing] = React.useState(false);

  const progress = useProgressWithNavigation({
    progressMessage,
    reportStatus,
    reportId,
    projectId: "",
    allowNavigation: false,
    taskId,
  });

  useEffect(() => {
    if (reportStatus === "SUCCESS" || reportStatus === "FAILURE")
      statusUpdated();
  }, [reportStatus]);

  return (
    <div className="">
      {(completed ||
        failed ||
        reportStatus === "SUCCESS" ||
        reportStatus === "FAILURE" ||
        reportStatus === "REVOKED") && (
        <button
          onClick={async () => {
            setProcessing(true);
            await onDelete(taskId);
            setProcessing(false);
          }}
          className="text-red-500 border border-red-500 rounded-md hover:text-red-600 p-0.5 hover:bg-red-100 transition absolute top-[0px] right-[0px] disabled:bg-[#fff] "
          aria-label="Close"
          type="button"
          disabled={processing}
        >
          {processing ? (
            <div className="p-0.5">
              <Loader color="#DC2222" size="xs" />
            </div>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-3 h-3"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          )}
        </button>
      )}
      <LoadingBar
        progress={completed ? 100 : progress}
        failed={failed || reportStatus === "FAILURE"}
        message={
          reportStatus === "SUCCESS" || completed
            ? "Completed ✅"
            : reportStatus === "PENDING"
            ? "Pending"
            : reportStatus && reportStatus !== ""
            ? progressMessage
            : currentStep
        }
        notification={true}
      />
    </div>
  );
};

export default ReportTracker;
